import { useMutation, useQueryClient } from "@tanstack/react-query";
import giftCategoriesClient, { Gift } from "../../../../api/giftCategories";

const useOrderGiftMutation = (orderName: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (gift: Partial<Gift>) =>
      giftCategoriesClient.editOrderGift({ updatedOrderName: orderName, gift }),
    onSuccess: (gift: Gift) => {
      // Update the specific gift order cache
      queryClient.setQueryData(["giftOrder", orderName], gift);
      // Invalidate both the gift orders list and the specific gift order
      queryClient.invalidateQueries({
        queryKey: ["giftOrders"],
      });
      queryClient.invalidateQueries({
        queryKey: ["giftOrder", orderName],
      });
    },
  });
};

export default useOrderGiftMutation;
